<ngx-charts-bar-vertical
  [view]="view"
  [scheme]="colorScheme"
  [results]="data"
  [gradient]="gradient"
  [xAxis]="xAxis"
  [yAxis]="yAxis"
  [legend]="legend"
  [showXAxisLabel]="showXAxisLabel"
  [xAxisLabel]="xAxisLabel"
  [showYAxisLabel]="showYAxisLabel"
  [yAxisLabel]="yAxisLabel"
  [barPadding]="barPadding">
</ngx-charts-bar-vertical>
<div class="label">
  <span class="amount">{{this.highValue | pounds}} {{this.highValue | appcents}}</span>
  <span class="sub">{{label}}</span>
</div>
